<!-- ./src/components/Movie.vue -->
<template>
 <div class="container">
   <div class="row justify-content-center">
        <div class="col-md-12">
           <div class="card">
              <div class="card-header text-left">
                <a>
                  <router-link to="/home">
                    <img class="image col-xs-3" id="home" src="@/assets/news/home.png" height="50" width="50" alt="" />
                  </router-link> 
                </a> 
              </div>

             

              <!--<iframe class="margin-left margin-bottom" src="https://www.youtube.com/embed/tgbNymZ7vqY" height="140" width="213" frameborder=”5″ scrolling=”no” allowfullscreen=”allowfullscreen”></iframe>-->
              <iframe class="margin-left margin-bottom" src="https://www.youtube.com/embed/v2QGmGmN4fE" height="200" width="180" frameborder=”5″ scrolling=”no” allowfullscreen=”allowfullscreen”></iframe>
              <iframe class="margin-left margin-bottom" src="http://www.youtube.com/embed/?listType=user_uploads&list=D100HK" width="200" height="180" frameborder=”5″ scrolling=”no” allowfullscreen=”allowfullscreen”></iframe>
              <iframe class="margin-left margin-bottom" src="http://www.youtube.com/embed/?listType=user_uploads&list=APPLEDAILYHK" width="200" height="180" frameborder=”5″ scrolling=”no” allowfullscreen=”allowfullscreen”></iframe>

          </div>
        </div>
      </div>
  </div>
  <!-- /container --> 

</template>

<!-- ./src/components/Movie.vue -->
<script>


// define the external API URL
const API_URL = 'https://netflixroulette.net/api/api.php'
// Helper function to help build urls to fetch movie details from title
function buildUrl (title) {
  alert(`${API_URL}?title=${title}`)
  return `${API_URL}?title=${title}`
}
export default {
  name: 'movie', // component name
  data () {
    return {
      title: '',
      error_message: '',
      loading: false, // to track when app is retrieving data
      movie: {}
    }
  },
  methods: {
    fetchMovie () {
      let title = this.title
      if (!title) {
        alert('please enter a title to search for')
        return
      }
      this.loading = true 
      fetch(buildUrl(title))
      .then(response => response.json())
      .then(data => {
        this.loading = false
        this.error_message = ''
        
        if (data.errorcode) {
          this.error_message = `Sorry, movie with title '${title}' not found. Try searching for "Fairy tail" or "The boondocks" instead.`
          return
        }
        this.movie = data
      }).catch((e) => {
        console.log(e)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#movie {
  margin: 30px 0;
}
.loader {
  text-align: center;
}
.margin-left{
    margin-left: 30px;
}
.margin-top{
    margin-top: 3px;
}
.margin-bottom{
    margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/movie.vue